import React, { useState } from 'react'
import { Formik } from 'formik'
import { string, object } from 'yup'
import { navigate, useLocation } from '@reach/router'

import api from 'api'
import TextInput from 'components/textInput'
import FullScreenWrapper from 'components/fullScreenWrapper'
import Button from 'components/button'
import { errorNotification } from 'utils/notification'
import getQueryParams from 'utils/getQueryParams'
import { setCachedUser } from 'helpers/cachedUser'
import { Container, Form, PageTitle, Icon } from './styles'

const INITIAL_VALUES = {
	email: '',
	password: ''
}

const VALIDATION_SCHEMA = object().shape({
	email: string().email().required().label('Email'),
	password: string().min(6).required().label('Password')
})

function Login() {
	const [loading, setLoading] = useState(false)
	const searchQuery = useLocation().search

	async function onSubmit(formData) {
		setLoading(true)
		try {
			const {
				data: {
					user: { id, roles },
					access
				}
			} = await api.auth.login(formData)
			setCachedUser({ ...access, id, roles, refreshing: false })
			const { redirectUrl } = getQueryParams(searchQuery)
			navigate(redirectUrl || '/')
			setLoading(false)
		} catch (error) {
			setLoading(false)
			errorNotification(error.message || error)
		}
	}

	return (
		<FullScreenWrapper>
			<Container>
				<Icon
					src={require('assets/images/hive-full-logo-gray.svg')}
					alt="ue dark logo"
				/>
				<PageTitle>Login</PageTitle>
				<Formik
					initialValues={INITIAL_VALUES}
					onSubmit={onSubmit}
					validateOnBlur
					validationSchema={VALIDATION_SCHEMA}
				>
					{({ handleSubmit }) => (
						<Form onSubmit={handleSubmit}>
							<TextInput name="email" label="Email Address" />
							<TextInput name="password" label="Password" type="password" />

							<Button disabled={loading} onClick={handleSubmit} type="submit">
								Login
							</Button>
						</Form>
					)}
				</Formik>
			</Container>
		</FullScreenWrapper>
	)
}

export default Login
